import React, { Component, createRef } from 'react';
import { Segment, Container, Input, List, Label, Divider, Tab, Grid, Header, Image, Button, Menu, MenuItem, Dropdown, Icon, Transition, Checkbox, Popup } from 'semantic-ui-react';
import { Link, useParams } from 'react-router-dom';
// import fuzzysort from 'fuzzysort';
import axios from 'axios';
import '../App.css';
import { API_URL, WEB_URL } from '../App.js';
import raw2026Videos from './transcriptions2026/raw2026Videos';
import {groups} from './transcriptions2026/allgroupedsrts.js';
import {subtitles} from './transcriptions2026/all2026srts.js';
// import { YugtunLoader, WordItem, TagColors } from './SearchHelper.js';
// import { customFontFam3, customTitleFontFam3, customFirefoxTitleFontFam } from './constants/constants.js';
// import { customFontFam3, customTitleFontFam3, customFirefoxTitleFontFam } from './constants/constants.js';

// import { sanitize } from 'dompurify';
// import {categories} from './constants/categories.js';
// import {categoriesUrlLookup} from './constants/categoriesUrlLookup.js';

// import { dialogueGenerator } from './constants/dialogueListGenerator.js';
//test

import * as Scroll from 'react-scroll';
// import { Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
// import ReactGA from "react-ga4";
// ReactGA.initialize("G-BCN5V0JQN1")

var scroll    = Scroll.animateScroll;

let customFontFam3 = "'Libre Franklin',Arial,Helvetica,sans-serif"
let customFontFam2 = "'Libre Franklin',Arial,Helvetica,sans-serif"
let customFontFam = "'Libre Franklin',Arial,Helvetica,sans-serif"
let customTitleFontFam3 = "'Raleway',Arial,Helvetica,sans-serif"
let customFirefoxTitleFontFam = "Arial,Helvetica,sans-serif"


let innerWidthSetting = 480

class VideoList2026 extends Component {
	constructor(props) {
		super(props);
    // console.log(props.location)
		this.state = {
			// search: props.location.state === undefined ? '' :props.location.state.history[0],
			// wordsList: props.location.state === undefined ? [] : props.location.state.history[1],
      // sortOptionValue: props.location.state === undefined ? 1 : props.location.state.history[2],
      // showOptionValue: props.location.state === undefined ? 1 : props.location.state.history[3],
      // homeMode: 0,
      // props.location.state === undefined ? 0 : ('currentCategory' in props.location.state && props.location.state.currentCategory !== 'all' ? 3 : props.location.state.history[3]),
      // activeAudioIndex: props.location.state === undefined || 'currentCategory' in props.location.state && props.location.state.currentCategory !== 'all' ? {} : props.location.state.history[4],
      // normalizedresults: props.location.state === undefined || props.location.state.history === undefined ? false : props.location.state.history[4],
      history: props.location.state === undefined ? [] : props.location.state.history,
      gridLayout: true,

		}
    // console.log('new')
		this.handleRef = createRef()
		// this.handleRef2 = createRef()

	}


	render() {
    console.log(groups)
    // console.log(this.props)
		// let isCommon = false
    // // let displayList = (this.state.search.length >= 1 && this.state.wordsList.length > 0) || (this.state.homeMode === 3 && this.state.wordsList.length > 0);
    // let wordsList = this.state.wordsList;
    // if (wordsList.length == 0) {
    //   // if (this.state.showOptionValue != 1) {
    //   //   wordsList = this.state.sortedSiuSearchList
    //   // } else {
    //   //   wordsList = this.state.siuSearchList
    //   // }
    //   wordsList = this.state.zoomSearchList
    // }
    // let emptyList = this.state.search.length >= 1 && this.state.wordsList.length === 0 && this.state.activeTabIndex !== 3;
    // let categoryMargin = '4px'
    let showLargerTable = window.innerWidth >= 480
    // let ranDem = this.state.randomSentences[this.state.randomSentenceIndex]
    // wordsList.map((k)=>{
    //   console.log(k)
    //   k = fuzzysort.highlight(k[0], '<b>', '</b>')
    //   console.log(k)
    // })

  // const panes = [
  //   {
  //     menuItem: (
  //     	<Menu.Item style={customFontFam2}>
  //     	<div><span>Dictionary Entry</span> </div>
  //     	</Menu.Item>
  //     	),
  //   },
  //   {
  //     menuItem: (<div />),
  //   },
  //   {
  //     menuItem: (
  //     	<Menu.Item style={customFontFam2}>
  //     	<div><span>Audio Clip</span> </div>
  //     	</Menu.Item>
  //     	),
  //   },
  //   {
  //     menuItem: (
  //       <Menu.Item style={customFontFam2}>
  //       <div><span>Category</span> </div>
  //       </Menu.Item>
  //       ),
  //   },
  //   ];
    // console.log(raw2026Videos)
		return (
			<div className="app" style={{fontFamily:customFontFam}}>
      <Grid textAlign='center'>
      <Grid.Row>
        <Grid.Column style={{ maxWidth: 860, padding: 0 }} textAlign='left'>
            <div className='yugtatun'>Nutarat Suuliaret</div>
            <div className='yugtatunsub'>Yugtun Video Collection (2026)</div>
        </Grid.Column>
      </Grid.Row>


    <Button.Group>
      <Button active={this.state.gridLayout} onClick={()=>this.setState({gridLayout:!this.state.gridLayout})} icon>
        <Icon name='grid layout' />
      </Button >
      <Button active={!this.state.gridLayout} onClick={()=>this.setState({gridLayout:!this.state.gridLayout})} icon>
        <Icon name='list' />
      </Button>
     </Button.Group>

      <Grid.Row style={{ padding: 0 }}>
        <Grid.Column style={{ maxWidth: 860, padding: 0 }} textAlign='left'>
          <div style={{fontSize:'16px',color:'#00000099',marginTop:'5px',marginBottom:'3px',textAlign:'center'}}>Video results by date: </div>
        </Grid.Column>
      </Grid.Row>

      <Grid.Row style={{paddingTop:0}}>
        <Grid.Column style={{  maxWidth: 1060, padding: 0, fontFamily:customFontFam }} textAlign='left'>
          <div style={{display:'flex',flexWrap:'wrap',fontSize:'16px',justifyContent:'center'}}>
          {Object.keys(raw2026Videos).map((y,yindex)=>
            showLargerTable ? 
                <div style={{width:"200px",margin:'15px'}}>
                  <Link to={{pathname: '/2026list/'+y, state: { from: this.props.location.pathname, history:[this.state.search,this.state.wordsList, this.state.sortOptionValue, this.state.showOptionValue, this.state.Yposition] }}}>
                    <Image style={{borderRadius:'10px'}} src={'https://img.youtube.com/vi/'+y+'/sddefault.jpg'} />
                    {/*<div style={{color:'#000000DE',fontWeight:'600'}}>{'Inupiaraaqta Zoom'}</div>*/}
                  </Link>
                  <div style={{color:'#000000DE',fontWeight:'600',fontSize:'16px',marginTop:'5px',marginBottom:'3px'}}>{raw2026Videos[y].date}</div>
                  <div style={{fontSize:'14px',lineHeight:'16px',color:'#00000099'}}>{raw2026Videos[y]['general-description']}</div>
                </div>
                :
                <Grid style={{marginTop:0}}>
                  <Grid.Row columns={2} style={{alignItems:'center',margin:'3px 10px'}}>
                    <Grid.Column width={7}>
                    <Link to={{pathname: '/2026list/'+y, state: { from: this.props.location.pathname, history:[this.state.search,this.state.wordsList, this.state.sortOptionValue, this.state.showOptionValue, this.state.Yposition] }}}>
                      <Image style={{borderRadius:'10px'}} src={'https://img.youtube.com/vi/'+y+'/sddefault.jpg'} />
                      {/*<div style={{color:'#000000DE',fontWeight:'600'}}>{'Inupiaraaqta Zoom'}</div>*/}
                    </Link>
                    </Grid.Column>
                    <Grid.Column width={9}>
                    <div style={{color:'#000000DE',fontWeight:'600',fontSize:'16px',marginTop:'5px',marginBottom:'3px'}}>{raw2026Videos[y].date}</div>
                    <div style={{fontSize:'14px',lineHeight:'16px',color:'#00000099'}}>{raw2026Videos[y]['general-description']}</div>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
            
          )}
          </div>
        </Grid.Column>
      </Grid.Row>



      </Grid>


			</div>
		);
	}
}
export default VideoList2026;